define((require) => {
    "use strict";

    const Class         = require("shared/util/Class");
    const Preconditions = require("shared/util/Preconditions");

    return Class.extend({}, {
        rgbaToHex(rgba) {
            Preconditions.checkArguments(rgba);

            const {
                r, g, b, a
            } = this.parseRgba(rgba);
            const hex = `#${this._componentToHex(r)}${this._componentToHex(g)}${this._componentToHex(b)}`;

            return {
                hex,
                a
            };
        },

        isValidHex(hex, prefixed) {
            let result = true;

            if (prefixed) {
                if (hex.charAt(0) !== "#") {
                    result = false;
                }

                hex = hex.slice(1);
            }

            if (hex.length !== 3 && hex.length !== 6) {
                result = false;
            }

            hex.split("")
                .forEach((character) => {
                    const to16 = parseInt(character, 16);
                    if (to16 > 15 || isNaN(to16)) {
                        result = false;
                    }
                });

            return result;
        },

        hexToRgba(hex, alpha) {
            Preconditions.checkArguments(hex, alpha);
            Preconditions.condition(".length === 7", hex);

            alpha = parseFloat(alpha, 10);
            if (alpha < 0) alpha = 0;
            if (alpha > 1) alpha = 1;

            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            const rgbObj = {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            };

            return `rgba(${rgbObj.r}, ${rgbObj.g}, ${rgbObj.b}, ${alpha})`;
        },

        parseRgba(rgba) {
            const numberMatches = rgba.match(/(?:\d*\.)?\d+/g);
            const rgbaArray = numberMatches.map((str) => parseFloat(str, 10));

            // Alpha is set to undefined, it isn't used anywhere in the code for now.
            // But the old implementation did return the property.
            return {
                r: rgbaArray[0],
                g: rgbaArray[1],
                b: rgbaArray[2],
                a: rgbaArray[3] || undefined
            };
        },

        formatRgbaToHex({r, g, b}) {
            return `#${this._componentToHex(r)}${this._componentToHex(g)}${this._componentToHex(b)}`;
        },

        formatRgbaToStyle({
            r, g, b, a
        }) {
            return `rgba(${r},${g},${b},${a || 1})`;
        },

        _componentToHex(c) {
            const hex = c.toString(16);
            return hex.length === 1 ? `0${hex}` : hex;
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/util/Color.js